import SubTabSection from '../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection';
import SubTabParent from '../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent';
import FormInput from '../../../../_shoru_shared_library/components/form/FormInput';
import FormSelect from '../../../../_shoru_shared_library/components/form/FormSelect';
import { useState } from 'react';
import FormButton from '../../../../_shoru_shared_library/components/form/FormButton';


function SeasonsTab(props) {

  const [localSeason, setLocalSeason] = useState(null);

  const seasons = props.organisationData.seasons.filter((x) => x.active);

  let options = seasons.map((s) => {
    return <option value={s.uid}>{s.name}</option>
  })

  return (
    <SubTabParent passData={props}>
      <SubTabSection description='Choose the season you want to run ClashBot on. ClashBot cannot be run on inactive seasons.'>
        <FormSelect required addNull title='Season' value={localSeason} setValue={setLocalSeason} >
          {options}
        </FormSelect>

        <FormButton onClick={() => {props.additional.setSeason(localSeason)}} accentColour={props.accentColour} label='Next' />
      </SubTabSection>
    </SubTabParent>
  )

}

export default SeasonsTab;